import React, { useEffect, useState } from "react";
import WelcomeBanner from "./welcomeBanner";
import Stats from "./stats";
import Calendar from "./calendar";
import TaskList from "./taskList";
import Prescription from "./prescription";
import TodoList from "./todoList";
import { useNavigate } from "react-router-dom";
import { Path } from "../../RoutesUtils";
import { getService, PostService } from "../../services/genericPostService";
import Swal from "sweetalert2";
import moment from "moment";
import { resources_EN } from "../componentUtils";
import SchedulerList from "../schedulerPage/SchedulerList";
import ReminderPopup from "../reminderPopup/reminderPopup";
import Header from "../header/header" 

const Dashboard = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [homeData, setHomeData] = useState({
    prescriptions: [],
    recent_activities: [],
    tasks: [],
  });
  const [notificationData, setNotificationData] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    } else {
      dashboardApi(selectedDate);
    }
  }, []);

  useEffect(() => {
    checkNotification();
    const interval = setInterval(checkNotification, 300000);

    return () => clearInterval(interval);
  }, []);

  const dashboardApi = (date) => {
    const data = {
      date: moment(date).format("YYYY-MM-DD"),
      user_id: userId,
    };

    const url = "/fmeApi/dashboard.php";
    PostService(url, data, modal);
  };

  const modal = (icon, title, message, response) => {
    if (icon === resources_EN.error) {
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
      });
    } else {
      setHomeData(response.data);
    }
  };

  const checkNotification = () => {
    const url = "/fmeApi/get_notifications.php";
    getService(url, "", setNotifyData);
  };

  const setNotifyData = (response) => {
    if (response.length > 0) {
      setNotificationData(response);
      setShowNotification(true);
    }
  };

  const closeNotification = () => {
    setShowNotification(false);
  };

  console.log("Responseeeeeeeee", homeData);
  return (
    <>
    <Header />
    <div className="bg-gray-50 min-h-screen mt-5">
      <main className="mx-auto ">
        <div className="flex flex-col lg:flex-row">
          <div className="flex-1 relative">
            <WelcomeBanner userData={homeData.users} />
            <div className="-mt-10 z-10 relative max-w-4xl mx-auto lg:px-8 px-4">
              <Stats schedule={homeData.schedule} />
              <SchedulerList
                schedules={homeData.schedule}
                selectedDate={selectedDate}
                getHomeData={dashboardApi}
              />
            </div>
          </div>
          <div className="w-full lg:w-1/3 space-y-8 p-6 bg-[#F3F3F3]">
            <div className="container max-w-sm">
              <Calendar
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                getHomeData={dashboardApi}
              />
              <TodoList
                activities={homeData.tasks}
                selectedDate={selectedDate}
                getHomeData={dashboardApi}
              />
              <Prescription prescriptions={homeData.prescriptions} />
            </div>
          </div>
        </div>
      </main>
      <ReminderPopup
        isOpen={showNotification}
        isClose={closeNotification}
        data={notificationData}
      />
    </div>
    </>
  );
};

export default Dashboard;
